export const VuesticTheme = {
  Primary: 'Primary',
  Danger: 'Danger',
  Info: 'Info',
  Success: 'Success',
  Warning: 'Warning',
  White: 'White',
  Black: 'Black',
}

export const colorConfig = {
  [VuesticTheme.Primary]: '#4ae387',
  [VuesticTheme.Danger]: '#e34a4a',
  [VuesticTheme.Info]: '#4ab2e3',
  [VuesticTheme.Success]: '#db76df',
  [VuesticTheme.Warning]: '#f7cc36',
  [VuesticTheme.White]: '#fff',
  [VuesticTheme.Black]: '#000',
}

export const colorArray = Object.values(colorConfig)
